module.exports = __webpack_public_path__ + "img/caseImg.347e120f.png";